export const sizeDesktop = 920;
